import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { AI_BASE_URL } from "../../lib/aiApiBaseUrl"
import { apiRequest } from "../../lib/request"

/** User-wide inbox summary (all properties). Do not send client_ids — backend scopes by user. */
export const fetchInboxSummary = createAsyncThunk(
  "inboxSummary/fetch",
  async ({ userId } = {}, { rejectWithValue }) => {
    try {
      if (!userId) return rejectWithValue("userId is required")
      const url = `${AI_BASE_URL}/api/inbox/user/${userId}/summary`
      const data = await apiRequest(url, { method: "GET" })
      return { userId: String(userId), data }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch inbox summary")
    }
  },
  {
    condition: ({ userId, force } = {}, { getState }) => {
      if (force) return true
      const uid = userId != null ? String(userId) : ""
      if (!uid) return false
      const s = getState().inboxSummary
      if (s.status === "loading" && String(s.userId ?? "") === uid) return false
      if (s.status === "succeeded" && String(s.userId ?? "") === uid) return false
      return true
    },
  },
)

const initialState = {
  data: null,
  userId: null,
  status: "idle",
  error: null,
}

const inboxSummarySlice = createSlice({
  name: "inboxSummary",
  initialState,
  reducers: {
    clearInboxSummary: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInboxSummary.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchInboxSummary.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.userId = action.payload?.userId ?? null
        state.data = action.payload?.data || null
      })
      .addCase(fetchInboxSummary.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearInboxSummary } = inboxSummarySlice.actions
export default inboxSummarySlice.reducer
